import { Input as AntInput } from "antd";
import "../style.scss";

function Input({
  id,
  placeholder,
  type = "text",
  label,
  value,
  icon,
  onChange,
  addonAfter,
  className,
  inputClassname,
  labelClass,
  restrictAction,
  variant = "",
  maxLength,
  onBlur,
  readOnly,
  isDisabled,
  onKeyPress,
}) {
  return (
    <div className={`flex flex-col w-full gap-1 ${className}`}>
      {label && (
        <label
          className={`input-label ${labelClass ? labelClass : ""}`}
          htmlFor={id}
        >
          {label}
        </label>
      )}

      <AntInput
        disabled={isDisabled}
        readOnly={readOnly}
        maxLength={maxLength}
        type={type}
        className={` ${inputClassname} ${variant === "dotted" ? "dotted-input" : ""}`}
        id={id}
        placeholder={placeholder}
        value={value}
        suffix={icon}
        onKeyPress={onKeyPress}
        onChange={onChange}
        onBlur={onBlur}
        addonAfter={addonAfter}
        onCopy={restrictAction ? (e) => e.preventDefault() : undefined}
        onPaste={restrictAction ? (e) => e.preventDefault() : undefined}
        onCut={restrictAction ? (e) => e.preventDefault() : undefined}
        onKeyDown={
          type === "number"
            ? (e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }
            : undefined
        }
      />
    </div>
  );
}

export default Input;
